<div *ngFor="let code of regionCodes">
    {{code.pincode}}
</div>